<style scoped>
.section {
  margin-top: -1px;
}

.list-container {
  display: inline-block;
  width: 13.5em;
  height: 19.0em;
  vertical-align: top;
  padding-top: 0.5em;
}

.list {
  padding-left: 1.0em;
}
.list+.list {
  height: 10.5em;
}

.icon-cell {
  width: 1.7em;
}

.mark {
  width: 1.6em;
  height: 1.6em;
}

.quest-host-icon-image {
  margin: 0px;
  padding: 0px;
  width: 1.6em;
  height: 1.6em;
  margin-top: -0.2em;
}

.name-short {
  display: block;
  height: 1.7em;
  width: 10em;
  padding-left: 0.1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<template>
  <div class="section border border-1 border-dark pt-2 pb-2 ps-2" v-cloak>
    <span>
      <button class="btn btn-sm btn-primary" @click="broadcasting.panelOpened = !broadcasting.panelOpened">
        <i class="fa fa-bars"></i>
      </button>
      <h2 class="ms-2 header">配信用固定エリア</h2>
      <a class="ms-2 ext-link" target="_blank" href="https://scrapbox.io/mhrise-queque/display-capture-area"><i class="fas fa-question-circle"></i></a>
    </span>
    <CollapseTransition class="mt-2 ps-4">
      <div v-show="broadcasting.panelOpened">
        <div class="list-container d-inline-block border border-1 border-dark"
          v-bind:style="{color: fgGeneralColor, fontFamily: fgFont, textShadow: fgShadow, backgroundColor: transparentColor}">
          <div v-if="listsShown">
            <div v-if="joinedListShown" class="list">
              <h2 class="header">クエ貼り</h2>
              <table class="mt-1">
                <tr v-for="m in sortedJoinedMembers" :key="m.index">
                  <template v-if="displayed(m)">
                    <td class="icon-cell" style="vertical-align: top">
                      <template v-if="isQuestHost(m)">
                        <span class="mark current-quest-host-icon-mark" v-show="! isCustomQuestHostIconEnabled" />
                        <img class="quest-host-icon-image" v-show="isCustomQuestHostIconEnabled" v-bind:src="others.questHostIconImage">
                      </template>
                    </td>
                    <td class="text-cell">
                      <span class="name-short" v-bind:style="{color: fgNameColor}">{{m.name}} {{guestNameSuffix(m)}}</span>
                    </td>
                  </template>
                </tr>
              </table>
            </div>
            <div v-if="waitingListShown" class="list">
              <span>
                <h2 class="header">参加待ち</h2>
                <span> ({{waiting.members.length}}名)</span>
              </span>
              <table class="mt-1">
                <tr v-for="(m, i) in slicedWaitingMembers" :key="i">
                  <td class="icon-cell"></td>
                  <td class="text-cell">
                    <span class="name-short" v-bind:style="{color: fgNameColor}">{{m.name}} {{guestNameSuffix(m)}}</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="ms-2 p-0 list-container d-inline-block border border-1 border-dark"
          v-bind:style="{backgroundColor: transparentColor}">
          <div v-if="listsShown" v-bind:style="{backgroundColor: backgroundColor}" style="height: 100%">
          </div>
        </div>
        <div class="ms-2 d-inline-block">
          <div>
            <span>リスト表示設定</span>
            <table class="ms-4 table table-bordered" style="width: 13.0em">
              <tr>
                <td style="width:1.6em"></td>
                <td style="width:1.6em" class="text-center">ロビー</td>
                <td style="width:1.6em" class="text-center">クエスト</td>
              </tr>
              <tr>
                <td>クエ貼り</td>
                <td class="text-center"><input type="checkbox" v-model="broadcasting.displayJoinedListInLobby" /></td>
                <td class="text-center"><input type="checkbox" v-model="broadcasting.displayJoinedListInQuest" /></td>
              </tr>
              <tr>
                <td>参加待ち</td>
                <td class="text-center"><input type="checkbox" v-model="broadcasting.displayWaitingListInLobby" /></td>
                <td class="text-center"><input type="checkbox" v-model="broadcasting.displayWaitingListInQuest" /></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </CollapseTransition>
    <!--
    <pre>{{$props}}</pre>
    <pre>{{$data}}</pre>
    -->
  </div>
</template>

<script>
import { CollapseTransition } from "@ivanv/vue-collapse-transition"
import JoinedMembers from '@/components/resource/JoinedMembers'

export default {
  components: {
    CollapseTransition,
  },
  props: {
    config: { type: Object, required: true },
    broadcasting: { type: Object, required: true },
    joined: { type: Object, required: true },
    waiting: { type: Object, required: true },
    others: { type: Object, required: true },
    game: { type: Object, required: true },
  },
  computed: {
    fgGeneralColor() {
      return this.others.maskEnabled
        ? this.others.color
        : this.config.others.defaultColor
    },
    fgNameColor() {
      return this.others.maskEnabled
        ? this.others.nameColor
        : this.config.others.defaultNameColor
    },
    transparentColor() {
      return this.others.maskEnabled
        ? this.others.transparentColor
        : this.config.defaultBackgroundColor
    },
    backgroundColor() {
      return this.others.maskEnabled
        ? this.others.backgroundColor
        : this.config.defaultBackgroundColor
    },
    fgFont() {
      return this.others.fontFamilyEnabled
        ? this.others.fontFamily
        : ''
    },
    fgShadow() {
      let c = this.others.textShadowColor
      return this.others.textShadowEnabled
        //? `-1px 0px ${c}, 1px 0px ${c}, 0px -1px ${c}, 0px 1px ${c}`
        ? Array(16).fill(`0 0 3px ${c}`).join(', ')
        : 'none'
    },
    listsShown() {
      return ! this.game.infoDisplayOnRightSide
    },
    joinedListShown() {
      if (! this.joined.duringQuest && this.broadcasting.displayJoinedListInLobby) return true
      if (this.joined.duringQuest && this.broadcasting.displayJoinedListInQuest) return true
      return false
    },
    waitingListShown() {
      if (! this.joined.duringQuest && this.broadcasting.displayWaitingListInLobby) return true
      if (this.joined.duringQuest && this.broadcasting.displayWaitingListInQuest) return true
      return false
    },
    sortedJoinedMembers: {
      cache: false,
      get() {
        return JoinedMembers.sortedMembers(this.joined)
      }
    },
    slicedWaitingMembers() {
      return this.waiting.members.slice(0, this.slicedWaitingMembersCount)
    },
    slicedWaitingMembersCount() {
      let baseRows = this.config.broadcasting.waitingMemberSliceCount

      let joinedListShown = (! this.broadcasting.displayJoinedListInLobby && ! this.joined.duringQuest) ||
                            (! this.broadcasting.displayJoinedListInQuest && this.joined.duringQuest)
      let additionalRows = joinedListShown
                           ? this.config.broadcasting.joinedListSpace
                           : this.config.maxJoinedMemberCount - this.joined.members.filter(m => this.canQuestHost(m)).length
      
      return baseRows + additionalRows
    },
    canQuestHost() {
      return (m) => {
        return (this.joined.questHostTypes.host && m.joinedOrder == 1)
            || (this.joined.questHostTypes.support && m.isSupport)
            || (this.joined.questHostTypes.guest && m.joinedOrder != 1 && !m.isSupport)
      }
    },
    isQuestHost() {
      return (m) => {
        return this.joined.members[m.index] == this.joined.questHost
      }
    },
    isCustomQuestHostIconEnabled() {
      return this.others.questHostIconEnabled && this.others.questHostIconImage != ''
    },
    guestNameSuffix() {
      return m => {
        if (! this.others.guestNameSuffixEnabled) return ''
        if (m.joinedOrder == 1) return ''
        if (m.isSupport) return ''
        return this.others.guestNameSuffix
      }
    },
  },
  methods: {
    order(m) {
      return this.joined.questHostOrder == 'display'
        ? m.displayOrder
        : m.joinedOrder
    },
    displayed(m) {
      if (! this.joined.questHostTypes.host && m.joinedOrder == 1) return false
      if (! this.joined.questHostTypes.support && m.isSupport) return false
      if (! this.joined.questHostTypes.guest && m.joinedOrder != 1 && ! m.isSupport) return false
      return true
    }
  }
}
</script>
